"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var RenameFieldTransform = /** @class */ (function (_super) {
    __extends(RenameFieldTransform, _super);
    function RenameFieldTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenameFieldTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        if (queryResponse && typeof queryResponse === 'object') {
            var renameFieldOptions = this.options.renameFieldOptions;
            if (renameFieldOptions) {
                var original = renameFieldOptions.original, replacement = renameFieldOptions.replacement;
                if (original && replacement && queryResponse.hasOwnProperty(original)) {
                    queryResponse[replacement] = queryResponse[original];
                    delete queryResponse[original];
                }
            }
        }
        return response;
    };
    return RenameFieldTransform;
}(BaseTransform_1.BaseTransform));
exports.RenameFieldTransform = RenameFieldTransform;
//# sourceMappingURL=RenameFieldTransform.js.map